import { combineReducers } from 'redux'
import { getPasswordError, addErrorClass } from 'utils/misc'
import request from 'utils/request'
import { navigateTo } from 'navigation'

const USER_ACTIVATED = 'USER_ACTIVATED'
const UPDATE_NEW_PASSWORD = 'UPDATE_NEW_PASSWORD'

function activateUser(token, resetPw = false) {
  return dispatch => {
    const success = jsonBody => {
      const payload = Object.assign(
        JSON.parse(atob(jsonBody.token.split('.')[1])),
        jsonBody
      )
      if (!payload.username || !payload.id) {
        navigateTo('/unauthorized')
        throw new Error('Unable to authenticate user ')
      }
      if (jsonBody.hasPassword && !resetPw) {
        navigateTo('/users/me')
        throw new Error('You have already set your password')
      }
      dispatch({
        type: USER_ACTIVATED,
        token: jsonBody.token
      })
    }
    return dispatch(
      request({
        method: 'POST',
        url: '/control/users/verify_token',
        body: JSON.stringify({ token }),
        failMessage: 'Unable to authenticate user.',
        success,
        authRequired: false,
        headerOptions: {
          Authorization: token
        }
      })
    )
  }
}

function setNewPassword(passwordState, token) {
  return (dispatch, getState) => {
    const { strings } = getState()
    const passwordError = getPasswordError(
      passwordState.password,
      passwordState.password_confirmation,
      dispatch,
      strings
    )
    if (!passwordError) {
      const success = () => {
        navigateTo('/login')
      }
      return dispatch(
        request({
          method: 'POST',
          url: `/control/users/setup_password`,
          body: JSON.stringify(Object.assign({}, passwordState, { token })),
          successMessage: 'Password set successfully',
          success,
          authRequired: false,
          headerOptions: {
            Authorization: token
          }
        })
      )
    } else {
      addErrorClass(['user-password', 'user-password-confirmation'])
    }
  }
}

function updateNewPassword(field, value) {
  return {
    type: UPDATE_NEW_PASSWORD,
    field,
    value
  }
}

// reducers

function changePasswordState(
  state = { password: '', password_confirmation: '' },
  action
) {
  switch (action.type) {
    case UPDATE_NEW_PASSWORD: {
      return Object.assign({}, state, { [action.field]: action.value })
    }
    default: {
      return state
    }
  }
}

function userToken(state = null, action) {
  switch (action.type) {
    case USER_ACTIVATED:
      return action.token
    default:
      return state
  }
}

export default combineReducers({
  changePasswordState,
  userToken
})

export const actions = {
  activateUser,
  updateNewPassword,
  setNewPassword
}
